var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "icon" }, [
    _c("i", { staticClass: "fas fa-info-circle info-icon" }),
    _vm._v(" "),
    _c("div", { staticClass: "info-popup", style: _vm.bodyStyle }, [
      _c("div", { staticClass: "arrow" }),
      _vm._v(" "),
      _vm.title
        ? _c("header", { style: _vm.headerStyle }, [_vm._v(_vm._s(_vm.title))])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "p",
        [
          _vm._v("\n            " + _vm._s(_vm.text) + "\n            "),
          _vm._t("default")
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e8b01a9", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e8b01a9","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/Popover.vue
// module id = null
// module chunks = 